import * as angular from "angular";
import * as _ from "lodash";

import {IController, IQService} from "angular";
import {PlanningPanelModel} from "../../models/planning-panel.model";
import {PlanningDraftExportType} from "../../types/planning-draft-export.type";
import {PlanningDraftsService} from "../../services/planning-drafts-service.service";
import {SiteNavMenuService} from "../../../commons/angular/services/site-nav-menu.service";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";
import {JobSuggestion} from "../../models/job-suggestion.model";
import {
  InsightEntityType,
  RecommendationHolderType,
  RecommendationProcessModel
} from "../../../recommendation/models/recommendation.model";
import {AiAgentModel} from "../../../ai-agents/models/ai-agent.model";
import {PlanningViewMode} from "../../types/planning-view-mode.enum";

export class PlanningProjectNavbarComponent implements IController {

  project: any;
  projectDraftIds: string[];
  selectedDraft: any;
  selectedDraftPanels: PlanningPanelModel[];
  defaultDraftId: string;
  isShowMap: boolean;
  isShowPanels: boolean;
  isGroupedRoutes: boolean;
  viewMode: PlanningViewMode;
  isShowMultipleJobSplit: boolean;
  isDisableDispatch: boolean;
  showViewModeToggle: boolean;
  onAddPanel: Function;
  onTogglePanels: Function;
  onCompareDrafts: Function;
  onToggleGroupedRoutes: Function;
  onToggleViewMode: Function;
  onExportDraftSvg: Function;
  onExportDraftRoutesLoadingSheetSvg: Function;
  onEditDraftSettings: Function;
  onOpenDraftJobChanges: Function;
  onEditProjectSettings: Function;
  onToggleShowMap: Function;
  onApproveAndDispatchDraft: Function;
  onBackToProjects: Function;
  onSelectDraft: Function;
  onBulkJobSplit: Function;
  onOpenRoutePanelsByIds: Function;

  public planningDraftExportType: typeof PlanningDraftExportType = PlanningDraftExportType;
  public readonly planningViewMode: typeof PlanningViewMode = PlanningViewMode;
  public drafts: any[];
  public isShowBackToProjectButton: boolean;
  public isSmallScreen: boolean;
  public readonly recommendationHolderType: RecommendationHolderType = RecommendationHolderType.Planning;
  public readonly insightEntityType: InsightEntityType = InsightEntityType.Draft;
  public listRecommendationsAllowed: boolean = false;
  public generateRecommendationsAllowed: boolean = false;

  constructor(private planningDraftsService: PlanningDraftsService, private $state,
              private siteNavMenuService: SiteNavMenuService, private planningConstants,
              private $q: IQService, private planningDialogService: PlanningDialogService,
              private IAMPermissions) {
  }

  $onInit() {
    this.drafts = [];
    this.isShowBackToProjectButton = this.$state.current.name === "planning.project.draft";
    if (this.projectDraftIds?.length) {
      this.setDrafts(this.projectDraftIds, []);
    }
    this.isSmallScreen = window.innerWidth < 1300;
    this.listRecommendationsAllowed = this.IAMPermissions.hasPermission('recommendation.list');
    this.generateRecommendationsAllowed = this.IAMPermissions.hasPermission('recommendation.generate');
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.projectDraftIds && !changes.projectDraftIds.isFirstChange()) {
      const currentDraftIds = _.get(changes.projectDraftIds, 'currentValue'),
        previousDraftIds = _.get(changes.projectDraftIds, 'previousValue');

      this.setDrafts(currentDraftIds, previousDraftIds);
    }
  }

  $onDestroy() {
  }

  onOpenProject() {
    this.$state.go('planning.project.project', {project: this.project.id}, {
      notify: true,
      reload: false
    });
  }

  onSelectProject(project) {
    if (project.selectedDraftId) {
      this.$state.go(this.planningConstants.states.draft, {projectId: project.id, draftId: project.selectedDraftId});
    } else {
      this.$state.go(this.planningConstants.states.project, {projectId: project.id});
    }
  }


  onOpenBulkJobSplitDialog({$event}) {
    const projectId = this.project.id;
    const draftId = this.selectedDraft.id;
    this.planningDraftsService.generateJobSplitSuggestions(projectId, draftId)
      .then((suggestions: JobSuggestion[]) => {
        this.planningDialogService.openBulkJobSplitDialog(suggestions, $event)
          .then((suggestionChoices) => {
            this.onBulkJobSplit({ $event: suggestionChoices })
          });
      })
  }

  onOpenProjectsDialog({$event}) {
    this.planningDialogService.projectsInfo(this.project, $event);
  }

  onRoutePanelsClicked(routeIds: string[]) {
    this.onOpenRoutePanelsByIds({ $event: routeIds });
  }

  onOpenKpiDialog({$event}) {
    this.$q.all({
      accountsData: this.planningDraftsService.getAccountsMetrics(this.project.id, this.selectedDraft.id),
      solutionData: this.planningDraftsService.getSolutionMetrics(this.project.id, this.selectedDraft.id)
    })
      .then((data) => {
        this.planningDialogService.openKpiDialog(data.accountsData, data.solutionData, $event);
      })
  }

  onGenerateRecommendations = (agent: AiAgentModel): Promise<RecommendationProcessModel> => {
    return this.planningDraftsService.generateDraftRecommendation(
      this.project.id,
      this.selectedDraft.id,
      agent.id
    ) as Promise<RecommendationProcessModel>;
  }

  private setDrafts(currentDraftIds: string[], previousDraftIds: string[]) {
    const draftIdsToRemove = _.differenceBy(previousDraftIds, currentDraftIds);
    const draftIdsToAdd = _.difference(currentDraftIds, previousDraftIds);

    if (_.size(draftIdsToRemove)) {
      _.forEach(draftIdsToRemove, (idToRemove) => {
        const draftIndex = this.drafts.findIndex(d => d.id === idToRemove);
        this.drafts.splice(draftIndex, 1);
      })
    }

    if (_.size(draftIdsToAdd)) {
      this.getDrafts(draftIdsToAdd).then((drafts: any) => {
        this.drafts = drafts;
      })
    }

  }

  private getDrafts(draftIds: string[]) {
    return this.planningDraftsService.getDrafts(draftIds, this.project.id);
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectNavbar', {
    bindings: {
      project: '<',
      projectDraftIds: '<?',
      selectedDraft: '<?',
      isShowMap: '<?',
      isShowPanels: '<?',
      isGroupedRoutes: '<?',
      viewMode: '<?',
      isDisableDispatch: '<?',
      isShowMultipleJobSplit: '<?',
      selectedDraftPanels: '<?',
      defaultDraftId: '<?',
      showViewModeToggle: '<?',
      onAddPanel: '&',
      onTogglePanels: '&',
      onCompareDrafts: '&',
      onToggleGroupedRoutes: '&',
      onToggleViewMode: '&',
      onExportDraftSvg: '&',
      onExportDraftRoutesLoadingSheetSvg: '&',
      onEditDraftSettings: '&',
      onOpenDraftJobChanges: '&',
      onEditProjectSettings: '&',
      onToggleShowMap: '&',
      onApproveAndDispatchDraft: '&',
      onBackToProjects: '&',
      onSelectDraft: '&',
      onBulkJobSplit: '&',
      onOpenRoutePanelsByIds: '&'
    },
    template: require('./planning-project-navbar.html').default,
    controller: PlanningProjectNavbarComponent
  });
